package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.data.BlogPost
import org.lennycodes.hldi.styles.AddAdminButtonStyle
import org.lennycodes.hldi.styles.UsersTitleStyle


@Composable
fun Blog() {

    val scope = rememberCoroutineScope()

    var showAddBlog by remember { mutableStateOf(false) }

    var refreshKey by remember { mutableStateOf(0) }

    var blogPosts by remember { mutableStateOf<List<BlogPost>>(emptyList()) }

    var selectedBlog by remember { mutableStateOf<BlogPost?>(null) }


    LaunchedEffect(refreshKey) {

        try {

            blogPosts = AdminRepository.getAllBlogs()

        } catch (e: Throwable) {

            console.error(
                "Loading blogs failed: ${e.message}"
            )

        }

    }


    if (showAddBlog) {

        AddBlogDialog(

            onDismiss = {
                showAddBlog = false
            },

            onSuccess = {
                showAddBlog = false
                refreshKey++
            }

        )

    }


    if (selectedBlog != null) {

        UpdateBlogDialog(

            blog = selectedBlog!!,

            onDismiss = {
                selectedBlog = null
            },

            onSuccess = {
                selectedBlog = null
                refreshKey++
            }

        )

    }


    Column(
        modifier = Modifier.fillMaxWidth().padding(32.px),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Top
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            H3(
                attrs = UsersTitleStyle.toAttrs()
            ) {
                Text("Blog List")
            }

            Button(
                modifier = Modifier
                    .padding(10.px, 20.px)
                    .then(AddAdminButtonStyle.toModifier()),
                onClick = {
                    showAddBlog = true
                }
            ) {
                Text("+ New BlogPost")
            }

        }


        if (blogPosts.isEmpty()) {

            P {
                Text("No blog posts yet.")
            }

        }


        SimpleGrid(
            numColumns = ResponsiveValues(
                base = 1,
                sm = 1,
                md = 2,
                lg = 3,
                xl = 3,
                xxl = 4
            ),
            modifier = Modifier.gap(20.px)
        ) {

            blogPosts.forEach { blog ->

                Div(
                    attrs = Modifier
                        .fillMaxWidth()
                        .padding(16.px)
                        .toAttrs()
                ) {

                    if (blog.imageUrl.isNotBlank()) {

                        Img(
                            src = blog.imageUrl,
                            attrs = Modifier
                                .fillMaxWidth()
                                .height(160.px)
                                .toAttrs()
                        )

                    }


                    H4 {
                        Text(blog.title)
                    }

                    P {
                        Text(blog.category)
                    }

                    P {
                        Text(blog.content)
                    }

                    P {
                        Text(blog.date)
                    }


                    Row(
                        horizontalArrangement =
                            Arrangement.spacedBy(10.px)
                    ) {

                        Button(
                            onClick = {
                                selectedBlog = blog
                            }
                        ) {
                            Text("Edit")
                        }


                        Button(
                            onClick = {

                                scope.launch {

                                    try {

                                        deleteDoc(
                                            doc(
                                                collection(
                                                    FirebaseService.db,
                                                    "blogs"
                                                ),
                                                blog.id
                                            )
                                        ).await()

                                        refreshKey++

                                    } catch (e: Throwable) {

                                        console.error(
                                            "Failed to delete blog: ${e.message}"
                                        )

                                    }

                                }

                            }
                        ) {
                            Text("Delete")
                        }

                    }

                }

            }

        }

    }

}